module.exports = __webpack_public_path__ + "img/96ne.dade2422.svg";